import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import dayjs from "dayjs";
import React from "react";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import Skeleton from "react-loading-skeleton";
import { useDateRange } from "../hooks";
dayjs.extend(isSameOrAfter);

const displayFormat = "DD.MM.YY";
export function TimePagination({ visibleRange, children }) {
  const { end, interval, next, prev } = useDateRange();

  return (
    <div className="flex gap-1 items-center">
      {interval && (
        <ChevronLeftIcon onClick={() => prev()} className="h-8 w-8" />
      )}
      <div className="flex flex-col gap-">
        <span className="flex">
          {!visibleRange.length && "Kein gültiger Zeitraum"}
          {visibleRange[0] ? (
            dayjs(visibleRange[0]).format(displayFormat)
          ) : (
            <Skeleton width={50} />
          )}{" "}
          -{" "}
          {visibleRange[1] ? (
            dayjs(visibleRange[1]).format(displayFormat)
          ) : (
            <Skeleton width={50} />
          )}
        </span>
        {children}
      </div>
      {interval && dayjs().isSameOrAfter(dayjs(end)) && (
        <ChevronRightIcon onClick={() => next()} className="h-8 w-8" />
      )}
    </div>
  );
}
